

const sleep = (t) => new Promise((r) => setTimeout(r, t));

export function swiperInit() {
	var defaultSettingSwiper = {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		rewind: true,
		speed: 1205,
		loop: false,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
	};
	var primarySwiper = new Swiper(".primary-banner .swiper", {
		...defaultSettingSwiper,
		slidesPerView: 1,
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".primary-banner .next",
			prevEl: ".primary-banner .prev",
		},
		pagination: {
			el: ".primary-banner  .swiper-pagination",
			type: "bullets",
			clickable: true,
		},
	});

	$(".init-swiper .swiper").each(function (index) {
		var $this = $(this);
		$this.addClass("swiper-init-" + index);
		$this
			.parents(".init-swiper")
			.find(".prev")
			.addClass("prev-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".next")
			.addClass("next-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".swiper-pagination")
			.addClass("pagination-inst-" + index);

		var swiper = new Swiper(".swiper-init-" + index, {
			...defaultSettingSwiper,
			slidesPerView: "auto",
			navigation: {
				nextEl: ".next-nav-" + index,
				prevEl: ".prev-nav-" + index,
			},
			pagination: {
				el: ".pagination-inst-" + index,
				type: "bullets",
				clickable: true,
				dynamicMainBullets: 1,
			},
		});
	});



	var productThumb = new Swiper(" .product-thumb .swiper", {
		spaceBetween: 20,
		breakpoints: {
			200: {
				slidesPerView: 3,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 25,
			},
		},
		speed: 500,
		lazy: {
			loadPrevNext: true,
		},
	});
	var productMain = new Swiper(".product-main .swiper", {
		spaceBetween: 10,
		centeredSlides: true,
		speed: 1205,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".product-thumb .next",
			prevEl: ".product-thumb .prev ",
		},
		thumbs: {
			swiper: productThumb,
		},
	});



	var historyThumb = new Swiper(".history-thumb .swiper", {
		spaceBetween: 20,
		centeredSlides: true,
		slideToClickedSlide: true,
		breakpoints: {
			200: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 5,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 6,
				spaceBetween: 40,
			},
			1200: {
				slidesPerView: 7,
				spaceBetween: 40,
			},
		},
		speed: 500,
		lazy: {
			loadPrevNext: true,
		},
	});
	var historyMain = new Swiper(".history-main .swiper", {
		spaceBetween: 40,
		speed: 1205,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".history-main .next",
			prevEl: ".history-main .prev ",
		},

	});
	// Link controllers:
	historyThumb.controller.control = historyMain;
	historyMain.controller.control = historyThumb;



	var gridSwiper = new Swiper(".about-5 .swiper", {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		rewind: true,
		speed: 1205,
		loop: false,
		autoplay: false,
		lazy: {
			loadPrevNext: true,
		},
		spaceBetween: 20,
		observeParents: true,
		simulateTouch: false,
		breakpoints: {
			240: {
				slidesPerView: 2,
				spaceBetween: 10,
			},
			576: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1024: {
				spaceBetween: 40,
				slidesPerView: 4,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
		},
		navigation: {
			nextEl: ".about-5 .next",
			prevEl: ".about-5 .prev",
		},
	});
}